import axiosInstance from './axiosInstance'
import { buildFlexyAlmacenesPath } from '../constants/flexyAlmacenesApiPaths'
import { DEFAULT_FLEXY_IDEMPRESA } from '../constants/flexyStock'
import type { FlexyAlmacen, FlexyAlmacenesQuery, FlexyAlmacenesResponse } from '../types/flexyAlmacenes'

class FlexyAlmacenesService {
  async getAlmacenes(query: FlexyAlmacenesQuery = {}): Promise<FlexyAlmacen[]> {
    const path = buildFlexyAlmacenesPath({
      idempresa: query.idempresa ?? DEFAULT_FLEXY_IDEMPRESA,
      activo: query.activo ?? '1'
    })
    const response = await axiosInstance.get<FlexyAlmacenesResponse>(path)
    return Array.isArray(response.data?.data) ? response.data.data : []
  }
}

export const flexyAlmacenesService = new FlexyAlmacenesService()
export default flexyAlmacenesService
